import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Carousel from "react-multi-carousel";
// import Play_Button from "../images/play-button.png";
import "../css/gallerysection.css";
import "../css/allvideosmodal.css";
import "react-multi-carousel/lib/styles.css";
import {
  generateYtThumbnail,
  imagePath,
  videoIdArray,
  generateYtVideoLink,
} from "../Utils/index";
import ReactPlayerWrapper from "./ReactPlayerWrapper";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const deviceType = window.innerWidth > 575 ? "desktop" : "mobile";
const screenWidthXHeight = [window.innerWidth, window.innerHeight];
const Videos = () => {
  const [isOpenSingleVideo, setIsOpenSingleVideo] = useState(false);
  const [currentVideoId, setCurrentVideoId] = useState("");
  const [mouseActivity, setMouseActivity] = useState(["", "", ""]);
  const [isLoading, setisLoading] = useState(["", "", ""]);
  const [modalContentHeight, setModalContentHeight] = useState(
    Math.round(0.7 * screenWidthXHeight[1])
  );
  const [videoItemsLength, setVideoItemsLength] = useState();
  const handleThumbnailClick = (e, id) => {
    e.preventDefault();
    setIsOpenSingleVideo(true);
    setCurrentVideoId(id);
  };

  const latestLoadingUpdate = (currentState) => {
    setisLoading(currentState);
  };

  useEffect(() => {
    // for shadow effect in list
    if (screenWidthXHeight[0] < 575) {
      setModalContentHeight(Math.round(0.3 * screenWidthXHeight[1]));
      return;
    }
    if (screenWidthXHeight[0] < 765) {
      setModalContentHeight(Math.round(0.3 * screenWidthXHeight[1]));
      return;
    }
    if (screenWidthXHeight[0] > 765 && screenWidthXHeight[0] < 1025) {
      setModalContentHeight(Math.round(0.45 * screenWidthXHeight[1]));
      return;
    }
    setModalContentHeight(400);
  }, [screenWidthXHeight]);

  const handleCustomArrowClick = (e, arrowType) => {
    e.preventDefault();
    const domInbuiltArrowName = arrowType === "Next" ? "right" : "left";
    const inbuiltArrow = document.querySelectorAll(
      ".react-multiple-carousel__arrow.react-multiple-carousel__arrow--" +
      domInbuiltArrowName
    );

    if (inbuiltArrow && inbuiltArrow.length === 1) {
      inbuiltArrow[0].click();
    }
  };
  const handleOverlayCloseClick = (e) => {
    setIsOpenSingleVideo(false);
    setCurrentVideoId("");
  };
  return (
    <div className="lightblue-bg">
      <Container>

        <div className="podcast-div"><h4 className="podcast-heading h4-align-centre orange-box-mobile">Podcast Highlights</h4></div>

        <div className="gallery-section-container">
          {isOpenSingleVideo && (
            <div
              className={`react-video-overlay ${isLoading ? "loader-present" : ""
                }`}
              id="draggable"
            >
              <div id="draggableHeader" title="Hold and drag to move this window">
                <button
                  title="Close"
                  className="react-video-overlay--close-btn"
                  onClick={(e) => handleOverlayCloseClick(e)}
                >
                  X
                </button>
              </div>
              <ReactPlayerWrapper
                width="auto"
                height={
                  screenWidthXHeight[0] < 575
                    ? Math.round(modalContentHeight * 1.6)
                    : modalContentHeight
                }
                url={generateYtVideoLink(currentVideoId)}
                latestLoadingUpdate={latestLoadingUpdate}
                deviceType={deviceType}
              />
            </div>
          )}
          <div className="video-grid ps-4 px-4">
            <div
              className="slider-custom-arrows video-grid-item arrow-left"
              style={{
                backgroundImage: `url(${imagePath}/arrow_left.svg)`,
              }}
              onClick={(e) => handleCustomArrowClick(e, "Previous")}
            ></div>
            <div
              className="slider-custom-arrows video-grid-item arrow-right"
              style={{
                backgroundImage: `url(${imagePath}/arrow_right.svg)`,
              }}
              onClick={(e) => handleCustomArrowClick(e, "Next")}
            ></div>
            <div className="middle-section video-grid-item">
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={true}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                // infinite={videoItemsLength !== videoIdArray.length ? false : true}
                infinite={false}
                centerMode={false}
                autoPlaySpeed={10000}
                keyBoardControl={true}
                customTransition="all .5"
                containerClass="carousel-container"
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
              >
                {videoIdArray.slice(0, videoItemsLength).map((item, index) => (
                  <>
                    <div key={index}>
                      <div className="thumbnail-container">
                        <div
                          className={`image-wrapper ${item.id === currentVideoId ? "now-playing" : ""
                            }`}
                        >
                          <Image
                            loading="lazy"
                            key={"img" + index}
                            className="thumbnail-image"
                            alt="Video thumbnail"
                            src={generateYtThumbnail(item.id)}
                            onClick={(e) => {
                              handleThumbnailClick(e, item.id);
                            }}
                            draggable="false"
                            // These three are just to override default onClick
                            onDragStart={() =>
                              setMouseActivity((state) => [
                                true,
                                state[1],
                                state[2],
                              ])
                            }
                            onMouseMove={() =>
                              setMouseActivity((state) => [
                                state[0],
                                true,
                                state[2],
                              ])
                            }
                            onDragEnd={() =>
                              setMouseActivity((state) => [
                                state[0],
                                state[2],
                                true,
                              ])
                            }
                          ></Image>
                        </div>

                        {/* } */}
                      </div>
                      <div>
                        <img
                          loading="lazy"
                          key={"playImg" + index}
                          // src={Play_Button}
                          // alt="playbutton"
                          // className="Play_Button"
                          onClick={(e) => {
                            handleThumbnailClick(e, item.id);
                          }}
                        />
                      </div>
                    </div>
                  </>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Videos;
